<template>

  <!-- Idea Question -->
  <div
    class="swot-analysis-wrapper"
    :class="{ 'disabled': disabled }"
  >

    <!-- Completed Overlay -->
    <div
      v-if="!canEdit || $store.state.idea.storyMode.common.completedSteps.swotAnalysisCompleted"
      class="completed-overlay"
      @click="onClick"
    />
    <!-- /Completed Overlay -->

    <div v-if="disabled" class="disabled-overlay" />

    <!-- Empty Card -->
    <div
      v-if="!text"
      class="question-card"
      :class="{ 'disabled': disabled, 'strengths': type === 'strengths', 'weaknesses': type === 'weaknesses', 'opportunities': type === 'opportunities', 'threats': type === 'threats', 'matching': matching, 'completed-card': $store.state.idea.storyMode.common.completedSteps.swotAnalysisCompleted }"
      @click="onClick"
    >
      <!-- Title -->
      <h3>{{ title }}</h3>
      <!-- /Title -->

      <!-- Description -->
      <p>{{ description }}</p>
      <!-- /Description -->

      <!-- Plus Button -->
      <el-button type="plus-round-xs" icon="el-icon-plus" />
      <!-- /Plus Button -->

      <span v-if="type === 'strengths'" class="text-mark d-none d-lg-block">
        S
      </span>

      <span v-if="type === 'weaknesses'" class="text-mark d-none d-lg-block">
        W
      </span>

      <span v-if="type === 'opportunities'" class="text-mark d-none d-lg-block">
        O
      </span>

      <span v-if="type === 'threats'" class="text-mark d-none d-lg-block">
        T
      </span>

    </div>
    <!-- /Empty Card -->

    <!-- Card With Data -->
    <div
      v-else
      class="question-card filled story-mode-swot-analysis-filled"
      :class="{ 'strengths': type === 'strengths', 'weaknesses': type === 'weaknesses', 'opportunities': type === 'opportunities', 'threats': type === 'threats' }"
      @click="onClick"
    >

      <!-- Pen icon -->
      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" v-if="canEdit && type === 'strengths'" v-bind:svg-inline="''" v-bind:class="'idea-pen'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="#0291ff" fill-rule="evenodd" d="M1.5 12.78l8.34-8.575 2.14 2.197-8.35 8.56H1.5v-2.183zM12.125 1.853l2.15 2.203-1.23 1.26L10.9 3.119l1.225-1.265zM.75 16.498h3.19c.2 0 .39-.082.53-.226L15.865 4.6a.777.777 0 000-1.086L12.655.225a.74.74 0 00-.53-.225.74.74 0 00-.53.225L.22 11.92a.796.796 0 00-.22.543v3.268c0 .425.335.768.75.768z"/></svg>
      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" v-if="canEdit && type === 'weaknesses'" v-bind:svg-inline="''" v-bind:class="'idea-pen'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="#e53935" fill-rule="evenodd" d="M1.5 12.78l8.34-8.575 2.14 2.197-8.35 8.56H1.5v-2.183zM12.125 1.853l2.15 2.203-1.23 1.26L10.9 3.119l1.225-1.265zM.75 16.498h3.19c.2 0 .39-.082.53-.226L15.865 4.6a.777.777 0 000-1.086L12.655.225a.74.74 0 00-.53-.225.74.74 0 00-.53.225L.22 11.92a.796.796 0 00-.22.543v3.268c0 .425.335.768.75.768z"/></svg>
      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" v-if="canEdit && type === 'opportunities'" v-bind:svg-inline="''" v-bind:class="'idea-pen'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="#0291ff" fill-rule="evenodd" d="M1.5 12.78l8.34-8.575 2.14 2.197-8.35 8.56H1.5v-2.183zM12.125 1.853l2.15 2.203-1.23 1.26L10.9 3.119l1.225-1.265zM.75 16.498h3.19c.2 0 .39-.082.53-.226L15.865 4.6a.777.777 0 000-1.086L12.655.225a.74.74 0 00-.53-.225.74.74 0 00-.53.225L.22 11.92a.796.796 0 00-.22.543v3.268c0 .425.335.768.75.768z"/></svg>
      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" v-if="canEdit && type === 'threats'" v-bind:svg-inline="''" v-bind:class="'idea-pen'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="#e53935" fill-rule="evenodd" d="M1.5 12.78l8.34-8.575 2.14 2.197-8.35 8.56H1.5v-2.183zM12.125 1.853l2.15 2.203-1.23 1.26L10.9 3.119l1.225-1.265zM.75 16.498h3.19c.2 0 .39-.082.53-.226L15.865 4.6a.777.777 0 000-1.086L12.655.225a.74.74 0 00-.53-.225.74.74 0 00-.53.225L.22 11.92a.796.796 0 00-.22.543v3.268c0 .425.335.768.75.768z"/></svg>
      <!-- /Pen icon -->

      <!-- Title -->
      <h3>{{ title }}</h3>
      <!-- /Title -->

      <!-- Divider -->
      <hr>
      <!-- /Divider -->

      <!-- Text -->
      <p class="clamped">
        <span class="inner-clamped d-block" v-html="text" />
      </p>
      <!-- /Text -->

    </div>
    <!-- /Card With Data -->

    <!-- Dialog Process Completed -->
    <dialog-process-completed
      :dialog-process-completed-visible="dialogProcessCompletedVisible"
      @close-dialog-process-completed="onCloseDialogProcessCompleted"
    />
    <!-- /Dialog Process Completed -->

  </div>
  <!-- /Idea Question -->
</template>

<script>
import DialogProcessCompleted from '@/views/Home/StoryMode/Components/Dialogs/DialogProcessCompleted'
import MixinIdeaRoles from '@/mixins/permissions/ideaRoles'
import MixinProcessCompleted from '@/mixins/processCompleted'
import { mapGetters } from 'vuex'

export default {
  name: 'SwotAnalysisElements',

  components: {
    DialogProcessCompleted
  },

  mixins: [
    MixinProcessCompleted,
    MixinIdeaRoles
  ],

  props: {
    type: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    matching: {
      type: Boolean,
      default: true
    },
    stepName: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters('idea', ['getStepIsCompleted']),

    isStepCompleted () {
      return this.getStepIsCompleted(this.stepName)
    }
  },

  mounted () {
    this.$nextTick(() => {
      const strengthsCardText = document.querySelector('.strengths .clamped')
      const strengthsCardTextInner = document.querySelector('.strengths .clamped .inner-clamped')

      const weaknessesCardText = document.querySelector('.weaknesses .clamped')
      const weaknessesCardTextInner = document.querySelector('.weaknesses .clamped .inner-clamped')

      const opportunitiesCardText = document.querySelector('.opportunities .clamped')
      const opportunitiesCardTextInner = document.querySelector('.opportunities .clamped .inner-clamped')

      const threatsCardText = document.querySelector('.threats .clamped')
      const threatsCardTextInner = document.querySelector('.threats .clamped .inner-clamped')

      if (strengthsCardText) {
        if ((strengthsCardTextInner.offsetHeight - 20) > strengthsCardText.offsetHeight) {
          strengthsCardText.classList.add('scrollable')
        } else {
          strengthsCardText.classList.remove('scrollable')
        }
      }

      if (weaknessesCardText) {
        if ((weaknessesCardTextInner.offsetHeight - 20) > weaknessesCardText.offsetHeight) {
          weaknessesCardText.classList.add('scrollable')
        } else {
          weaknessesCardText.classList.remove('scrollable')
        }
      }

      if (opportunitiesCardText) {
        if ((opportunitiesCardTextInner.offsetHeight - 20) > opportunitiesCardText.offsetHeight) {
          opportunitiesCardText.classList.add('scrollable')
        } else {
          opportunitiesCardText.classList.remove('scrollable')
        }
      }

      if (threatsCardText) {
        if ((threatsCardTextInner.offsetHeight - 20) > threatsCardText.offsetHeight) {
          threatsCardText.classList.add('scrollable')
        } else {
          threatsCardText.classList.remove('scrollable')
        }
      }
    })
  },

  methods: {
    onClick () {
      if (!this.canEdit) return
      if (this.isStepCompleted) {
        this.dialogProcessCompletedVisible = true

        return
      }
      this.$emit('click')
    }
  }
}
</script>
